// React
import { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

// MUI
import { Stack, CircularProgress, Typography } from "@mui/material";

// Components
import ReasonForVisitModal from "Components/ReasonForVisitModal";
import { ErrorDialog } from "Components/Users/Patient/UpcomingPastAppointments/Common/commonComponents";

// Resource/Utils
import { getClientByDomain } from "API/Resource/client";
import { getClientDomain } from "Utils/getClientDomain";

export const MBSReason = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [hasError, setHasError] = useState(false);
  const [openReasonForVisit, setOpenReasonForVisit] = useState(true);
  const [clientData, setClientData] = useState(null);
  const [isLoadingClient, setIsLoadingClient] = useState(true);

  const hasPatient = Boolean(location.state?.patient);

  const goHome = useCallback(() => {
    navigate("/mbs/home", { replace: true });
  }, [navigate]);

  useEffect(() => {
    if (!openReasonForVisit || !hasPatient) {
      goHome();
    }
  }, [goHome, openReasonForVisit, hasPatient]);

  useEffect(() => {
    const fetchClientData = async () => {
      try {
        setIsLoadingClient(true);
        const client = await getClientByDomain(getClientDomain());
        setClientData(client);
      } catch (error) {
        setHasError(true);
      } finally {
        setIsLoadingClient(false);
      }
    };

    if (openReasonForVisit) {
      fetchClientData();
    }
  }, [openReasonForVisit]);

  if (hasError) {
    return (
      <ErrorDialog
        open={hasError}
        onClose={goHome}
        errorMessage={t("errors.genericError")}
      />
    );
  }

  if (isLoadingClient) {
    return (
      <Stack spacing={2} alignItems="center">
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          {t("common.loading")}
        </Typography>
      </Stack>
    );
  }

  return (
    <ReasonForVisitModal
      open={openReasonForVisit}
      patient={location.state?.patient}
      client={clientData?.client}
      clinics={clientData?.clinics}
      setOpenReasonForVisit={setOpenReasonForVisit}
      isMBS
    />
  );
};
